import React from "react";

import styles from './Subtitle.module.css';
import dedoArriba from '../../img/vinetadedoarriba.png';

const Subtitle = (props) => {
    return (
        <React.Fragment>
            <div className={styles['areadatosprospecto__subtitulo']}>
                <img 
                    src={dedoArriba} 
                    alt=""
                />
                <h2>{props.sname}</h2>
            </div>
            { props.smostrar 
              ? <p className={styles['areadatosprospecto__subtitulo_info']}>{props.sparrafo}</p> 
              : ''
            }
        </React.Fragment>
    );
}

export default Subtitle;